import React from 'react';
import { Link } from 'react-router-dom';
import { defaultListProps } from '~constants/config';
import {
  List, NumberField, TextField, EditButton, DeleteWithConfirmButton, FunctionField, DateField,
  Filter, ReferenceInput, SelectInput, Button
} from 'react-admin';
import ContentAdd from '@material-ui/icons/Add';
import CustomDatagrid from '~components/CustomDatagrid';
import RecomputeStatusBanner from '~components/RecomputeStatusBanner';
import SearchableSelectInput from '~components/SearchableSelectInput';

const MetricValueFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput source="metric" reference="metrics" label="Métrica" alwaysOn sort={{ field: 'name', order: 'ASC' }} perPage={200}>
      <SearchableSelectInput placeholder="Métrica" />
    </ReferenceInput>
    <ReferenceInput source="pais" reference="countries" label="País">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput source="subsector" reference="subsectores" label="Subsector">
      <SelectInput optionText="name" />
    </ReferenceInput>
    <ReferenceInput source="etapa" reference="etapas" label="Etapa">
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

// Custom list actions so that, when a Métrica filter is active, the Create
// button carries that metric into the new form (via router state.record, which
// RA's CreateController reads first). filterValues is injected by ListToolbar.
function MetricValueListActions({ basePath, filterValues }) {
  const metric = filterValues && filterValues.metric;
  const to = metric
    ? { pathname: `${basePath}/create`, state: { record: { metric } } }
    : `${basePath}/create`;
  return (
    <Button component={Link} to={to} label="ra.action.create">
      <ContentAdd />
    </Button>
  );
}

function MetricValueList({ ...props }) {
  return (
    <>
      <RecomputeStatusBanner />
      <List {...defaultListProps} {...props} filters={<MetricValueFilter />} actions={<MetricValueListActions />}>
        <CustomDatagrid rowClick="edit">
          <FunctionField label="ID" render={record => record.id} />
          <TextField source="metricName" label="Métrica" />
          <TextField source="paisName" label="País" />
          <TextField source="etapaName" label="Etapa" />
          <TextField source="subsectorName" label="Subsector" />
          <NumberField source="value" />
          <TextField source="detalle" />
          <DateField source="createdAt" label="Creado" showTime />
          <DeleteWithConfirmButton label="" />
          <EditButton label="" />
        </CustomDatagrid>
      </List>
    </>
  );
}

export default MetricValueList;
